import { ChakraProvider as ChakraProviderBase, defaultSystem } from "@chakra-ui/react";

const ChakraProvider = ({ children }: { children: React.ReactNode }) => {
  return <ChakraProviderBase value={defaultSystem}>{children}</ChakraProviderBase>;
};

export default ChakraProvider;
